import { useEffect, useState } from "react";
import { useLoaderData, useLocation } from "react-router-dom";
import { ApiKeychainSchema } from "../../../utils/types";
import { Plus } from 'react-feather';
import { InternalLink } from "../../../components/internal-link/InternalLink";
import { ContentButton } from "../../../components/button/ContentButton";
import { Pagination } from "../../../components/pagination/Pagination";
import ApiKeychainCard from "./ApiKeychainCard";
import { useBreadcrumbs } from "../../../context/BreadcrumbsContext";

import "./DashboardApiKeychainsPage.scss";
import { InfoBox } from "../../../components/info/InfoBox";

export default function DashboardApiKeychainsPage() {

  const { updateBreadcrumbs } = useBreadcrumbs();
  const { apiKeychains, pagination } = useLoaderData() as {
    apiKeychains: Array<ApiKeychainSchema>;
    pagination: { currentPage: number; totalPages: number };
  };

  useEffect(() => {
    if (pagination.currentPage !== 1) {
      updateBreadcrumbs([
        {
          label: `Page ${pagination.currentPage}`,
          path: `/dashboard/api-keychains?p=${pagination.currentPage}`
        }
      ]);
    } else {
      updateBreadcrumbs([]);
    }
    return () => {
      updateBreadcrumbs([]);
    };
  }, [pagination.currentPage]);

  return (
    <div data-component="DashboardApiKeychainsPage">
      <div className="content-container">
        <div className="content-description">
          <InfoBox>
            Your API keychains are used to authenticate you with <InternalLink to="/packages">packages</InternalLink>.<br />
            You can create standalone API keychains to use packages in your own code.
          </InfoBox>
        </div>
        <div className="api-keychains-toolbar">
          <div className="spacer" />
          <ContentButton
            color="blue"
            to="/dashboard/api-keychains/new"
            icon={Plus}
          >
            Create API keychain
          </ContentButton>
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            basePath="/dashboard/api-keychains"
          />
        </div>
        {!apiKeychains.length && (
          <div className="no-api-keychains">
            You do not currently have any API keychains.<br />
          </div>
        )}
        {apiKeychains.length > 0 && (
          <>
            <div className="item-group">
              {apiKeychains.map((apiKeychain) => (
                <div key={apiKeychain.unique_id} className="item-entry">
                  <ApiKeychainCard apiKeychain={apiKeychain} />
                </div>
              ))}
            </div>
            <div className="api-keychains-toolbar">
              <div className="spacer" />
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                basePath="/dashboard/api-keychains"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
